/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 运维审核类型
 */
let EnumCompareStatus = {
	Transmit: 						new EnumItem('已下达', 0),
	Confirmed: 						new EnumItem('已确认', 1),
    Dealed: 						new EnumItem('已处理', 3),
	...enumMixn
}
export default EnumCompareStatus
